import React from "react";
import { motion } from "framer-motion";
import { t } from "../../i18n";

const HeroSection: React.FC = () => {
  return (
    <section className="bg-gradient-to-r from-primaryGreen via-primaryGreen to-[#8c52ff] py-20 w-[calc(100%-30px)] sm:w-[calc(100%-40px)] md:w-[calc(100%-60px)] mx-auto rounded-bl-[20px] rounded-br-[20px] mb-20">
      <div className="flex flex-col md:flex-row items-center md:justify-between w-full max-w-[1600px] mx-auto px-5 sm:px-10 md:px-10">
        <div className="w-full md:w-[48%] mb-10 md:mb-0">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.3, ease: "easeOut" }}
            className="text-3xl sm:text-4xl md:text-6xl  font-bold mb-6 text-white leading-tight text-left md:leading-[4rem]"
          >
            {t("hero.title")}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5, ease: "easeOut", delay: 0.3 }}
            className="text-white text-base sm:text-lg md:text-xl mb-10 font-tiny text-left"
          >
            {t("hero.subtitle")}
          </motion.p>

          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: "easeOut", delay: 0.6 }}
            onClick={() => {
              const contactElement = document.getElementById("contact");
              if (contactElement) {
                const headerOffset = 80;
                const elementPosition = contactElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                  top: offsetPosition,
                  behavior: "smooth",
                });
              }
            }}
            className="bg-white/100 text-primaryGreen font-bold px-6 sm:px-8 py-3 text-sm sm:text-md tracking-wider rounded-xl cursor-pointer"
          >
            {t("hero.cta")}
          </motion.button>
        </div>

        <div className="w-full md:w-[48%] flex justify-center">
          <img src="/images/firstPageLady.png" alt="" className="w-full max-w-[670px] h-auto" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
